module.exports = __webpack_public_path__ + "img/1F629.b71c0125.svg";